import React from 'react';
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete';
import styles from "./SearchBox.scss";
import {connect} from 'react-redux';
import { setSearchBoxResult } from "../../../../actions/Map/navActions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

class SearchBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      location: '',
      selectedLocation: {},
      readyToMark: false
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.readyToMark !== this.state.readyToMark){
      if (this.state.readyToMark){
        this.setState({ readyToMark: false })
        this.props.setSearchBoxResult(this.state.selectedLocation);
      }
    }
  }

  handleChange = location => {
    this.setState({ location: location });
  };

  clearSearch = () => {
    this.setState({ location: '' })
    this.props.setSearchBoxResult(undefined);
  }

  handleSelect = location => {
    this.setState({ location: location }, () => {
      geocodeByAddress(location + ", Kingston, Ontario, Canada")
        .then(results => {
          this.setState({
            selectedLocation: {
              name: this.state.location,
              address: results[0].formatted_address,
              place_id: results[0].place_id
            }
          })
          return getLatLng(results[0])
        })
        .then(latLng => {
          this.setState({
            selectedLocation: {
              ...this.state.selectedLocation,
              lat: latLng.lat,
              lng: latLng.lng,
            },
            readyToMark: true
          })
        })
        .catch(error => console.error('Error', error));
      })
  };

  render() {
    const searchOptions = {
      // location: new window.google.maps.LatLng(44.271839, -76.478064),
      // radius: 10000,
      // Using bounds, location & radius are ignored
      bounds:  {north: 44.521261, south: 44.160436, west: -76.842122, east: -76.058451}
    }

    return (
      <div>
        <PlacesAutocomplete
          value={this.state.location}
          onChange={this.handleChange}
          onSelect={this.handleSelect}
          searchOptions={searchOptions}
        >
          {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
            <div className={styles.SearchBox}>
              <FontAwesomeIcon
                onClick={() => this.clearSearch()}
                className={styles.closeButton}
                icon={faTimes}
              />
              <input
                {...getInputProps({
                  placeholder: 'Search places in Kingston...',
                  className: '',
                })}
              />
              <div className="autocomplete-dropdown-container">
                {loading &&
                <div className={styles.suggestion}>
                  {"Loading..."}
                </div>}
                <div className={styles.break} />
                {suggestions.map(suggestion => { // suggestions
                  const className = styles.suggestion;
                  // inline style for demonstration purpose
                  const style = suggestion.active
                    ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                    : { backgroundColor: '#ffffff', cursor: 'pointer' };
                  return (
                    <div
                      {...getSuggestionItemProps(suggestion, {
                        className,
                        style,
                      })}
                    >
                      <span>{suggestion.description}</span>
                      <div className={styles.break} />
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </PlacesAutocomplete>
      </div>
    )
  }
}


function mapStateToProps(state) {
  return {
    search_box_result: state.nav.search_box_result,
  };
}

const actions = { setSearchBoxResult }

export default connect(mapStateToProps, actions)(SearchBox);



// WEBPACK FOOTER //
// ./src/components/pages/Map/SearchBox/SearchBox.js